<script>
import numberedPropsToArray from '@/utils/numbered-props-to-array'

export default {
	inheritAttrs: false,
	props: {
		index: Number,
		data: Object,
	},
	computed: {
		bannerItems() {
			return numberedPropsToArray(this.data, 1)
		},
	},
}
</script>

<template>
	<Container>
		<v-row>
			<v-col>
				<BannerItem v-bind="bannerItems[0]" />
			</v-col>
		</v-row>
	</Container>
</template>
